import styled from 'styled-components';

const Site = styled.div`
	font-family: 'Playfair Display', sans-serif; 
	display: flex;
	flex-direction: column;
	min-height: 100vh;
`
export default Site